export const API_URL = process.env.REACT_APP_API_URL;
export const TOKEN_KEY = "access";
export const TOKEN_EXPIRY_DAYS = 30;

export const LORAWAN_SERVER_HOST: string =
  process.env.REACT_APP_LORAWAN_SERVER_HOST || "lns-dev.aurex.nolim.app";
export const LORAWAN_SERVER_PORT: string =
  process.env.REACT_APP_LORAWAN_SERVER_PORT || "1700";

export const VALIDATION_CLASS = "is-validation-error";

export const QUERY_PARAMS = {
  PAGE: "page",
  PAGE_SIZE: "page_size",
  STEP: "step",
  TAB: "tab",
  SEARCH: "search",
  STATUS: "status",
  SHOW_MORE: "show_more",

  COMPANY_ID: "company_id",
  COMPANY_LABEL: "company_label",
  PORTFOLIO_ID: "portfolio_id",
  ASSET_ID: "asset_id",
  MANAGER_ID: "manager_id",
  MANAGEABLE_ONLY: "manageable_only",
  GATEWAY_MODEL: "gateway_model",
  DEVICE_MODEL: "device_model",
  EXPORT_FORMAT: "export_format",
  INCIDENT_TYPE: "incident_type",
  SEVERITY: "severity",
  TIME_DETECTED_FROM: "time_detected_from",
  TIME_DETECTED_TO: "time_detected_to",
};

export const EMAIL_REGEX = /^[A-Za-z0-9]+(?:[.!#$%&'*+\/=?^_`{|}-][A-Za-z0-9]+)*@(?:[A-Za-z0-9-]+\.)+[A-Za-z0-9-]+$/;

export const MAX_PORTFOLIO_IMAGES = 10;
export const MAX_ASSET_IMAGES = 10;
export const MAX_IMAGE_SIZE = 5 * 1024 * 1024;
export const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp"];

export const ASSET_TYPE_OPTIONS = [
  { value: "Auditorium", label: "Auditorium" },
  { value: "Childcare Room", label: "Childcare Room" },
  { value: "Classroom", label: "Classroom" },
  { value: "Clinic", label: "Clinic" },
  { value: "Coworking", label: "Coworking" },
  { value: "Gym", label: "Gym" },
  { value: "Hospital Ward", label: "Hospital Ward" },
  { value: "Hotel Guest Room", label: "Hotel Guest Room" },
  { value: "Hotel Lobby", label: "Hotel Lobby" },
  { value: "Meeting Room", label: "Meeting Room" },
  { value: "Office", label: "Office" },
  { value: "Restaurant Dining Hall", label: "Restaurant Dining Hall" },
  { value: "Restaurant Kitchen", label: "Restaurant Kitchen" },
  { value: "Retail", label: "Retail" },
  { value: "School Hallway", label: "School Hallway" },
  { value: "Showroom", label: "Showroom" },
  { value: "Spa/Pool Hall", label: "Spa/Pool Hall" },
];
